import { TagIcon, ArrowRightIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import dubaiSkyline from "../assests/images/dubai-skyline.webp";

export default function LimitedTimeOffer() {
    const navigate = useNavigate();

    return (
        <section
            className="
                w-full
                bg-[#F3F8FF]
                py-10
                sm:py-12
                lg:py-16
            "
        >
            <div
                className="
                    mx-auto
                    max-w-[1380px]
                    px-5
                    sm:px-8
                    lg:px-12
                    xl:px-16
                "
            >
                <div
                    className="
                        group
                        relative
                        overflow-hidden
                        rounded-[28px]
                        border
                        border-[#E5E7EB]
                        bg-white
                        shadow-[0_20px_60px_rgba(11,85,82,0.10)]
                        transition-all
                        duration-500
                        hover:shadow-[0_25px_75px_rgba(11,85,82,0.16)]
                    "
                >
                    {/* =====================================================
                        BACKGROUND DECORATION
                    ===================================================== */}

                    <div
                        className="
                            pointer-events-none
                            absolute
                            -left-24
                            -top-24
                            h-64
                            w-64
                            rounded-full
                            bg-[#D7A74A]/10
                            blur-3xl
                        "
                    />

                    <div
                        className="
                            pointer-events-none
                            absolute
                            -bottom-32
                            left-[35%]
                            h-72
                            w-72
                            rounded-full
                            bg-[#8B0000]/5
                            blur-3xl
                        "
                    />

                    {/* =====================================================
                        MAIN CONTENT
                    ===================================================== */}

                    <div
                        className="
                            relative
                            z-10
                            grid
                            min-h-[390px]
                            grid-cols-1
                            lg:grid-cols-[1fr_0.95fr]
                        "
                    >
                        {/* =================================================
                            LEFT CONTENT
                        ================================================= */}

                        <div
                            className="
                                relative
                                flex
                                flex-col
                                justify-center
                                overflow-hidden
                                bg-[#0B5552]
                                px-6
                                py-10
                                sm:px-9
                                sm:py-12
                                lg:px-12
                                xl:px-16
                            "
                        >
                            {/* Gold curved decoration */}

                            <div
                                className="
                                    pointer-events-none
                                    absolute
                                    -right-28
                                    -top-28
                                    h-72
                                    w-72
                                    rounded-full
                                    border-[45px]
                                    border-[#D7A74A]/10
                                "
                            />

                            <div
                                className="
                                    pointer-events-none
                                    absolute
                                    -bottom-24
                                    -left-24
                                    h-52
                                    w-52
                                    rounded-full
                                    border
                                    border-[#D7A74A]/20
                                "
                            />

                            <div className="relative z-10 max-w-[610px]">

                                {/* Offer Label */}

                                <div
                                    className="
                                        mb-5
                                        inline-flex
                                        w-fit
                                        items-center
                                        gap-2.5
                                        rounded-full
                                        border
                                        border-[#D7A74A]/35
                                        bg-white/10
                                        px-3.5
                                        py-2
                                        backdrop-blur-sm
                                    "
                                >
                                    <span
                                        className="
                                            flex
                                            h-7
                                            w-7
                                            items-center
                                            justify-center
                                            rounded-full
                                            bg-[#D7A74A]
                                        "
                                    >
                                        <TagIcon
                                            className="h-3.5 w-3.5 text-[#0B5552]"
                                            strokeWidth={2}
                                        />
                                    </span>

                                    <span
                                        className="
                                            text-[9px]
                                            font-bold
                                            uppercase
                                            tracking-[0.22em]
                                            text-[#F4D98C]
                                            sm:text-[10px]
                                        "
                                    >
                                        Limited Time Offer
                                    </span>
                                </div>

                                {/* Small Eyebrow */}

                                <div
                                    className="
                                        mb-3
                                        flex
                                        items-center
                                        gap-3
                                    "
                                >
                                    <span
                                        className="
                                            h-px
                                            w-8
                                            bg-[#D7A74A]
                                        "
                                    />

                                    <span
                                        className="
                                            text-[10px]
                                            font-medium
                                            uppercase
                                            tracking-[0.18em]
                                            text-white/55
                                        "
                                    >
                                        Exclusive Dubai Hotel Deals
                                    </span>
                                </div>

                                {/* Heading */}

                                <h2
                                    className="
                                        max-w-[590px]
                                        font-serif
                                        text-[32px]
                                        font-medium
                                        leading-[1.08]
                                        tracking-[-0.025em]
                                        !text-white
                                        sm:text-[38px]
                                        md:text-[42px]
                                        lg:text-[44px]
                                        xl:text-[48px]
                                    "
                                >
                                    Make Your Dubai Stay
                                    <span
                                        className="
                                            block
                                            italic
                                            text-[#D7A74A]
                                        "
                                    >
                                        More Rewarding.
                                    </span>
                                </h2>

                                {/* Description */}

                                <p
                                    className="
                                        mt-4
                                        max-w-[500px]
                                        text-[12px]
                                        leading-[1.8]
                                        text-white/65
                                        sm:text-[13px]
                                        lg:text-sm
                                    "
                                >
                                    Discover handpicked hotels across Dubai
                                    and enjoy exclusive rates designed to make
                                    your next stay even more memorable.
                                </p>

                                {/* Bottom Row */}

                                <div
                                    className="
                                        mt-7
                                        flex
                                        flex-col
                                        gap-5
                                        sm:flex-row
                                        sm:items-center
                                    "
                                >
                                    {/* CTA */}

                                    <button
                                        type="button"
                                        onClick={() => navigate("/hotels")}
                                        className="
                                            group/button
                                            inline-flex
                                            w-fit
                                            items-center
                                            justify-center
                                            gap-2.5
                                            rounded-full
                                            bg-[#D7A74A]
                                            px-6
                                            py-3
                                            text-[11px]
                                            font-bold
                                            text-[#0B5552]
                                            shadow-[0_8px_25px_rgba(0,0,0,0.18)]
                                            transition-all
                                            duration-300
                                            hover:bg-[#E8C46D]
                                            hover:shadow-[0_12px_30px_rgba(0,0,0,0.24)]
                                            active:scale-[0.98]
                                        "
                                    >
                                        <span>
                                            Explore Offers
                                        </span>

                                        <ArrowRightIcon
                                            className="
                                                h-4
                                                w-4
                                                transition-transform
                                                duration-300
                                                group-hover/button:translate-x-1
                                            "
                                        />
                                    </button>

                                    {/* Trust */}

                                    <div
                                        className="
                                            flex
                                            items-center
                                            gap-2
                                            text-[10px]
                                            text-white/50
                                        "
                                    >
                                        <span
                                            className="
                                                h-1.5
                                                w-1.5
                                                rounded-full
                                                bg-[#D7A74A]
                                            "
                                        />

                                        <span>
                                            Exclusive rates • Secure booking
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* =================================================
                            RIGHT IMAGE
                        ================================================= */}

                        <div
                            className="
                                relative
                                min-h-[300px]
                                overflow-hidden
                                lg:min-h-full
                            "
                        >
                            <img
                                src={dubaiSkyline}
                                alt="Dubai skyline"
                                className="
                                    absolute
                                    inset-0
                                    h-full
                                    w-full
                                    object-cover
                                    object-center
                                    transition-transform
                                    duration-[1400ms]
                                    ease-out
                                    group-hover:scale-[1.05]
                                "
                            />

                            {/* Image overlay */}

                            <div
                                className="
                                    absolute
                                    inset-0
                                    bg-gradient-to-r
                                    from-[#0B5552]/35
                                    via-transparent
                                    to-black/10
                                "
                            />

                            <div
                                className="
                                    absolute
                                    inset-0
                                    bg-gradient-to-t
                                    from-black/35
                                    via-transparent
                                    to-transparent
                                "
                            />

                            {/* =================================================
                                40% OFFER BADGE
                            ================================================= */}

                            <div
                                className="
                                    absolute
                                    right-5
                                    top-5
                                    flex
                                    h-[112px]
                                    w-[112px]
                                    flex-col
                                    items-center
                                    justify-center
                                    rounded-full
                                    border
                                    border-white/50
                                    bg-white/95
                                    text-center
                                    shadow-[0_15px_40px_rgba(0,0,0,0.20)]
                                    backdrop-blur-md
                                    sm:right-7
                                    sm:top-7
                                    sm:h-[125px]
                                    sm:w-[125px]
                                "
                            >
                                <span
                                    className="
                                        text-[10px]
                                        font-bold
                                        uppercase
                                        tracking-[0.16em]
                                        text-[#8B0000]
                                    "
                                >
                                    Save Up To
                                </span>

                                <span
                                    className="
                                        mt-0.5
                                        font-serif
                                        text-[30px]
                                        font-bold
                                        leading-none
                                        text-[#0B5552]
                                        sm:text-[34px]
                                    "
                                >
                                    40%
                                </span>

                                <span
                                    className="
                                        mt-1
                                        text-[9px]
                                        font-semibold
                                        uppercase
                                        tracking-[0.12em]
                                        text-[#0B5552]/55
                                    "
                                >
                                    On Selected Stays
                                </span>
                            </div>

                            {/* =================================================
                                BOTTOM IMAGE LABEL
                            ================================================= */}

                            <div
                                className="
                                    absolute
                                    bottom-5
                                    left-5
                                    right-5
                                    sm:bottom-7
                                    sm:left-7
                                    sm:right-7
                                "
                            >
                                <div
                                    className="
                                        flex
                                        items-center
                                        justify-between
                                        gap-4
                                        rounded-2xl
                                        border
                                        border-white/20
                                        bg-black/20
                                        px-4
                                        py-3
                                        backdrop-blur-md
                                    "
                                >
                                    <div>
                                        <p
                                            className="
                                                font-serif
                                                text-lg
                                                italic
                                                text-white
                                            "
                                        >
                                            Dubai Awaits
                                        </p>

                                        <p
                                            className="
                                                mt-0.5
                                                text-[9px]
                                                uppercase
                                                tracking-[0.15em]
                                                text-white/60
                                            "
                                        >
                                            Luxury stays & unforgettable views
                                        </p>
                                    </div>

                                    <div
                                        className="
                                            hidden
                                            h-9
                                            w-9
                                            shrink-0
                                            items-center
                                            justify-center
                                            rounded-full
                                            border
                                            border-[#D7A74A]/60
                                            sm:flex
                                        "
                                    >
                                        <ArrowRightIcon
                                            className="
                                                h-4
                                                w-4
                                                text-[#D7A74A]
                                            "
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* =====================================================
                        OUTER BORDER
                    ===================================================== */}

                    <div
                        className="
                            pointer-events-none
                            absolute
                            inset-0
                            z-20
                            rounded-[28px]
                            border
                            border-white/60
                        "
                    />
                </div>
            </div>
        </section>
    );
}